import lodash from "lodash";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TaskModel } from "../../models/TaskModel.model";
import { List } from "@/shared/components/GenericSearchBar/model/List";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  GENERAL_RULES_CONSTANTS,
  STATUS_TASK,
  TASK_FIELDS,
  TASK_FORM_LABELS
} from "../../constants/GeneralRulesConstants";
import { Dependency } from "@/modules/Dependencies/models/Dependency";
import {
  FORM_MESSAGES,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import {
  NOTIFICATION_CONFIG,
  RECIPIENTS_INIT
} from "@/modules/Notification/constants/NotificationConstants";
import { UserStatus } from "@/modules/User/models/UserStatus";
import MessageRecipients from "@/shared/components/MessageRecipients/MessageRecipients.vue";
import Vuetify from "vuetify";
import { BasicObject } from "@/shared/constants/BasicObject";
import { PreventKey } from "@/shared/mixins/mixins";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import {
  TASK_CONSTANTS,
  VALUES_RESPONSIBLES
} from "@/modules/Tasks/constants/TaskConstants";
import { TaskForm } from "../../models/TaskForm.model";

Vue.use(Vuetify);
@Component({
  name: "Task",
  components: { MessageRecipients, DynamicSelect }
})
export default class Task extends PreventKey {
  @Prop({ default: false }) dialog!: boolean;
  @Prop() collection!: string;
  @Prop() taskToEdit!: TaskModel;
  @Prop({ default: 0 }) editDaysToApply!: number;
  @Prop() actionType!: string;
  @Prop() edit!: boolean;
  @Prop() formTemplatesList!: List[];

  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  secondaryBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  cardClass = STYLE_CLASSES.CARD;
  secondaryCardClass = STYLE_CLASSES.CARD_2;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  RECEIVERS_TEXT = NOTIFICATION_CONFIG.LABEL.RECEIVERS_TEXT;
  RESPONSIBLE_TEXT = TASK_CONSTANTS.LABELS.RESPONSIBLE;
  RELATED_TEXT = TASK_CONSTANTS.LABELS.RELATED;

  requiredField = [FORM_VALIDATORS.REQUIRED_FIELD];
  notBlankSpaces = [FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR];

  statusTask = STATUS_TASK;
  FORM = TASK_FIELDS.FORM;
  TASK_FORM_LABELS = TASK_FORM_LABELS;
  LIST_LOADING = TASK_FORM_LABELS.LIST_LOADING;

  isEditingRecipients = false;
  formTemplatesToSelect: List[] = [{ key: "", name: "" }];
  roleToSelect: List[] = [{ key: "", name: "" }];
  user = "";
  search = null;
  dependencies: Dependency[] = [];
  disableSaveButton = true;
  formKey = 0;
  resetComponents = 0;
  editingEvent = 0;
  taskFieldsValidation = false;
  isMappingData = false;
  taskFormTemplateModel = [{ id: "", name: "" }];
  taskFormSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    required: true,
    listAll: [],
    filled: false,
    messageLabel: this.TASK_FORM_LABELS.FORM,
    hideDetails: true
  };
  LABEL_RESPONSIBLE = TASK_CONSTANTS.LABELS.SELECT_RESPONSIBLE;
  configResponsibles = {
    patient: {
      label: TASK_CONSTANTS.LABELS.RADIO_PATIENT,
      value: VALUES_RESPONSIBLES.PATIENT
    },
    administrator: {
      label: TASK_CONSTANTS.LABELS.RADIO_ADMINISTRATOR,
      value: VALUES_RESPONSIBLES.ADMINISTRATOR
    }
  };

  taskForm: TaskForm = {
    selectedAffected: VALUES_RESPONSIBLES.PATIENT,
    selectTaskFormField: "",
    task: {
      name: "",
      required: false,
      formTemplate: "",
      recipients: lodash.cloneDeep(RECIPIENTS_INIT),
      affected: VALUES_RESPONSIBLES.PATIENT
    },
    daysToApply: this.editDaysToApply ?? 0
  };

  editComparationStr = "";
  invalidEdit = false;

  mounted() {
    this.updateDataDynamicSelect();
    this.preloadForm();
  }

  get selectTaskFormField() {
    return this.taskFormTemplateModel[0].id;
  }

  set selectTaskFormField(value: string) {
    const option = this.taskFormSelectConfig.listAll.find(
      item => item.id === value
    );
    this.taskFormTemplateModel = [
      {
        name: option?.name ?? "",
        id: option?.id ?? ""
      }
    ];
  }

  @Watch("selectTaskFormField")
  selectTaskFormFieldChanged() {
    this.taskForm.selectTaskFormField = this.taskFormTemplateModel[0].id;
  }

  @Watch("taskFormTemplateModel")
  onTaskFormTemplateModelChange() {
    this.taskForm.task.formTemplate = {
      key: this.taskFormTemplateModel[0].id,
      name: this.taskFormTemplateModel[0].name
    };
  }

  @Watch("edit")
  preloadForm() {
    if (this.edit) {
      this.isMappingData = true;
      const formTemplate = this.taskToEdit.formTemplate as {
        key: string;
        name: string;
      };
      this.taskForm.selectedAffected = this.taskToEdit.affected;
      this.selectTaskFormField = formTemplate.key;
      this.taskForm.selectTaskFormField = formTemplate.key;
      this.taskForm.task = lodash.cloneDeep(this.taskToEdit);
      this.taskForm.daysToApply = this.editDaysToApply;
      this.isEditingRecipients = true;
      this.editingEvent = 1 - this.editingEvent;
    } else {
      this.isEditingRecipients = false;
    }
  }
  @Watch("taskForm", { deep: true })
  checkEdit() {
    if (this.edit && this.editComparationStr != "") {
      this.invalidEdit =
        JSON.stringify(this.taskForm) === this.editComparationStr;
    } else if (this.edit && this.editComparationStr == "") {
      this.invalidEdit = true;
      this.editComparationStr = JSON.stringify(this.taskForm);
    }
  }

  deleteFormTemplate() {
    this.taskForm.task.formTemplate = "";
  }

  save() {
    if (
      this.taskForm.selectedAffected == VALUES_RESPONSIBLES.ADMINISTRATOR &&
      this.taskForm.task.recipients.defaultRecipients.length === 0 &&
      this.taskForm.task.recipients.dependencyUsers.length === 0 &&
      this.taskForm.task.recipients.dependencies.length === 0
    ) {
      Snackbar.popError(FORM_MESSAGES.TASK_WITHOUT_TO);
    } else {
      this.mapRecipients();
      this.$emit(
        GENERAL_RULES_CONSTANTS.EMITTERS.SAVE_TASK_ACTION,
        this.taskForm.task,
        this.taskForm.daysToApply
      );
      this.resetValues();
      this.taskForm.daysToApply = 0;
    }
  }

  cancel() {
    this.$emit(GENERAL_RULES_CONSTANTS.EMITTERS.CLOSE_MODAL);
    this.resetValues();
  }

  resetValues() {
    this.taskForm.task = {
      name: "",
      required: false,
      formTemplate: "",
      recipients: lodash.cloneDeep(RECIPIENTS_INIT),
      affected: VALUES_RESPONSIBLES.PATIENT
    };
    this.resetComponents = 1 - this.resetComponents;
  }

  updateDefault(defaultRecipients: string[]) {
    this.taskForm.task.recipients.defaultRecipients = defaultRecipients;
  }

  updateDependencies(dependencies: Dependency[]) {
    this.taskForm.task.recipients.dependencies = dependencies;
  }

  updateDependencyUsers(dependencyUsers: UserStatus[]) {
    this.taskForm.task.recipients.dependencyUsers = dependencyUsers;
  }

  mapRecipients() {
    this.taskForm.task.recipients.defaultRecipients = (this.taskForm.task
      .recipients.defaultRecipients as BasicObject[]).map(user => user ?? "");
    this.taskForm.task.recipients.dependencyUsers = (this.taskForm.task
      .recipients.dependencyUsers as UserStatus[]).map(user => user.id);
    this.taskForm.task.recipients.dependencies = (this.taskForm.task.recipients
      .dependencies as Dependency[]).map(template =>
      template.id ? template.id : ""
    );
  }

  recipientsConfigurationMapped() {
    this.isMappingData = false;
  }

  loadFormTemplates(name?: string) {
    this.$emit(GENERAL_RULES_CONSTANTS.EMITTERS.LOAD_FORM_TEMPLATES, name);
  }

  @Watch("formTemplatesList")
  updateDataDynamicSelect() {
    this.formTemplatesToSelect = this.formTemplatesList;
    this.taskFormSelectConfig.listAll = this.formTemplatesToSelect.map(item => {
      return { id: item.key, name: item.name };
    });
  }

  validateSaveButton() {
    return (
      (this.edit && this.invalidEdit) ||
      !this.taskFieldsValidation ||
      !this.taskForm.task.formTemplate ||
      (this.taskForm.selectedAffected == VALUES_RESPONSIBLES.ADMINISTRATOR &&
        this.taskForm.task.recipients.defaultRecipients.length === 0 &&
        this.taskForm.task.recipients.dependencyUsers.length === 0 &&
        this.taskForm.task.recipients.dependencies.length === 0)
    );
  }

  @Watch("taskForm.selectedAffected")
  loadAffected() {
    this.taskForm.task.affected = this.taskForm.selectedAffected;
    if (this.taskForm.selectedAffected === VALUES_RESPONSIBLES.PATIENT) {
      this.taskForm.task.recipients.defaultRecipients = [
        VALUES_RESPONSIBLES.USER
      ];
      this.taskForm.task.recipients.dependencyUsers = [];
      this.taskForm.task.recipients.dependencies = [];
      return;
    }
    this.taskForm.task.recipients.defaultRecipients = [];
  }
}
